import loadable from '@loadable/component';

export const namespace = 'canalplus.block.selfcare.payment';
export const Component = loadable(
  () => import('./containers/PaymentContainer')
);
export { default as propsFormatter } from './propsFormatter';
